import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';

import Layout from 'components/Layout';
import Meta from 'components/Meta';
import Banner from 'components/Banner';
import SectionContact from 'components/SectionContact';

import CheckIcon from 'images/icons/check.svg';

import { SolutionsDetail } from 'styles/solutions-detail';
import SolutionSteps from '../../components/SolutionSteps/SolutionSteps';

const SolutionTestingPage = ({ path }) => (
  <>
    <Meta
      title="Testing Service Providers | Software Testing | Automation Testing | ATC"
      description="ATC is one of the software testing service providers with modern quality assurance. We offer Automation, Compatibility, Security and Performance Testing"
    />
    <Layout background="#ffffff" path={path}>
      <SolutionsDetail>
        <Banner
          backgroundSrc="solutions/software-quality-banner.jpg"
          title="Testing - Always be improving the user’s experience."
          className="darken-image"
          style={{ paddingBottom: 100 }}
        >
          <p
            className="white-txt"
            style={{
              fontSize: 18,
              letterSpacing: 0.2,
              lineHeight: '28px',
            }}
          >
            At the heart of great user experience lies quality. Testing,
            reviews, and quality control, are mechanisms that help you build the
            next Salesforce, Tableau or Uber.
          </p>
          <Link
            to="/contact-us/"
            className="pink-btn"
            style={{ minWidth: 180 }}
          >
            <span>Learn how to get started</span>
          </Link>
          <a
            href="#brief"
            onClick={(e) => {
              e.preventDefault();
              if (typeof window !== 'undefined')
                window.scrollb.scrollIntoView(document.getElementById('brief'));
            }}
            className="white-btn brief-btn"
          >
            <span>What to expect</span>
          </a>
        </Banner>

        <section className="principle-main">
          <div className="container">
            <div className="row">
              <div className="col-md-12 col-lg-8">
                <h2 className="medium-heading">
                  Testing is not an internal affair
                </h2>
                <p className="white-txt">
                  Take advantage of access to testers with extensive hands-on
                  experience across scripted and exploratory testing
                  methodologies. Our competency extends beyond specific
                  techniques to include deep knowledge of cutting edge
                  automation testing tools such as Selenium, HPE Unified
                  Functional Testing, Mabl, TestCafe, and more. In addition to
                  the resources, frameworks, and tools, we offer comprehensive
                  support driven by performance metrics and SLAs.
                </p>
              </div>
            </div>
          </div>
        </section>

        <SolutionSteps id="testing" flyText="Testing and Quality Assurance" flyBoxImage="solutions/software-quality-box.jpg" />

        <section id="brief">
          <div className="grey-bg center">
            <div className="container">
              <div className="featured-partner-block">
                <h2 className="medium-heading black-txt">
                  Just like your product, testing evolves
                </h2>
                <p>
                  As newer paradigms in software development, such as Agile and
                  DevOps, gain prominence, and focus in your organization shifts
                  to automation, expertise in test design, test case
                  development, setting up and orchestrating test automation is
                  critical for rapid deployments that accelerate time to market
                  while keeping costs low.
                </p>
                <Link
                  to="/contact-us/"
                  className="pink-btn d-none d-md-inline-block"
                >
                  <span>Talk to an Expert</span>
                </Link>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="why-partner-main">
            <div className="container">
              <div className="row">
                <div className="col-md-4">
                  <h2 className="big-heading">
                    Managed Testing
                    <span className="pink">.</span>
                  </h2>
                </div>
                <div className="col-md-8">
                  <div className="row">
                    <div className="col-md-6 col-6">
                      <div className="why-partner-single">
                        <span className="why-partner-icon">
                          <CheckIcon />
                        </span>
                        <h3>Experience</h3>
                        <p>Extensive hands-on experience.</p>
                      </div>
                    </div>
                    <div className="col-md-6 col-6">
                      <div className="why-partner-single">
                        <span className="why-partner-icon">
                          <CheckIcon />
                        </span>
                        <h3>Methodology</h3>
                        <p>Scripted and exploratory testing.</p>
                      </div>
                    </div>
                    <div className="col-md-6 col-6">
                      <div className="why-partner-single">
                        <span className="why-partner-icon">
                          <CheckIcon />
                        </span>
                        <h3>Automation</h3>
                        <p>Automated testing to reduce error.</p>
                      </div>
                    </div>
                    <div className="col-md-6 col-6">
                      <div className="why-partner-single">
                        <span className="why-partner-icon">
                          <CheckIcon />
                        </span>
                        <h3>Support</h3>
                        <p>Support driven by performance metrics.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <SectionContact />
      </SolutionsDetail>
    </Layout>
  </>
);

SolutionTestingPage.propTypes = {
  path: PropTypes.string.isRequired,
};

export default SolutionTestingPage;
